module.exports = __webpack_public_path__ + "img/pwa-android-2.834e5cfd.png";